// extracted by mini-css-extract-plugin
module.exports = {"tiptapViewer":"TipTap_tiptapViewer__tHxpx","prose":"TipTap_prose__GSdFK","ProseMirror":"TipTap_ProseMirror__KqwDE"};